module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Edit outbound EDI Setup","bundleSupport":"EDI message bundle?","setupDetails":"EDI Setup","otherOptions":"Other options","codelists":"Codelists"},"no":{"title":"Rediger utgående EDI oppsett","bundleSupport":"Bundling av edi meldinger?","setupDetails":"EDI oppsett","otherOptions":"Andre instillinger","codelists":"Kodelister"}}')
  delete Component.options._Ctor
}
